import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { RunNPVForm } from '@/components/forms/pricing-interface/RunNPVForm/RunNPVForm'
import { RunNPVFormFields } from '@/components/forms/pricing-interface/RunNPVForm/RunNPVFormFields'

export interface RunNPVModalProps extends DialogProps {}

export const RunNPVModal: React.FC<RunNPVModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <RunNPVForm defaultValues={{ instance_tag: 'LOCALINST1' }}>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Run NPV</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <RunNPVFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </RunNPVForm>
      </DialogContent>
    </Dialog>
  )
}
